// removed by extract-text-webpack-plugin
module.exports = {"iconOnly":"ButtonStyles__iconOnly__3KUmZ","white":"ButtonStyles__white__B6E5D","small":"ButtonStyles__small__G5c2Q"};


//////////////////
// WEBPACK FOOTER
// ./src/Styles/ButtonStyles.scss
// module id = 653
// module chunks = 0